// extracted by mini-css-extract-plugin
export var buttons = "_4c-0";
export var buttonsActive = "_4c-h";
export var cancelConfirm = "_4c-1";
export var closeButton = "_4c-2";
export var column = "_4c-3";
export var container = "_4c-4";
export var detailHeader = "_4c-6";
export var detailTitle = "_4c-7";
export var detailsContent = "_4c-5";
export var header = "_4c-8";
export var headerWithClose = "_4c-9";
export var icon = "_4c-a";
export var infoIcon = "_4c-c";
export var informationContainer = "_4c-b";
export var sideDrawer = "_4c-d";
export var sideDrawerOpen = "_4c-e";
export var stickyFooter = "_4c-f";
export var typeOption = "_4c-g";